import { z } from 'zod'

export const configSchema = z.strictObject({
  launchDarkly: z.object({
    clientSideId: z.string(),
  }),
  env: z.string(),
  appName: z.string(),
  appVariant: z.string(),
  appVersion: z.string(),
})

export type Config = z.infer<typeof configSchema>
